
import CloseIcon from '@mui/icons-material/Close';
import {AppBar, Button, Dialog, IconButton, Toolbar } from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useWindowSize from '../../hooks/useWindowSize';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent,Transition} from '../shared/ReusableSmallComponents';

function DialogRejet({idDoc,missionId,missionIdProposition,openDialogRejet, handleCloseDialogRejet,handleCloseDialogVisualiserDocument}) {
    DialogRejet.propTypes = {
        idDoc: PropTypes.any,
        openDialogRejet: PropTypes.any,
        handleCloseDialogVisualiserDocument:PropTypes.func,
        handleCloseDialogRejet: PropTypes.func,
        missionId: PropTypes.any,
        missionIdProposition: PropTypes.any,

        //getDocumentAdministratifs:PropTypes.func,
    };

    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    //const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage } = useUtilities();
    const axiosPrivate = useAxiosPrivate();
    const [motifRejet,setMotifRejet]=useState('');
    const {device}=useWindowSize();
    const { i18n } = useTranslation();

    console.log('doc ID n rejet',idDoc);
    const rejeterDocument = async () => {
        try {
            console.log('doc ID n rejet',idDoc);
            if(idDoc){
                axiosPrivate.post('docAdministratif/changeDocStatus', { docId:idDoc,statut:'rejete',motifRejet:motifRejet})
                    .then(() => {
                        handleCloseDialogRejet();
                        handleCloseDialogVisualiserDocument();
                        setMotifRejet('');
                    })
                    .catch(error => console.log(error));
            }
            if(missionId){
                await axiosPrivate.post('/mission/switchordreMission',
                    { missionId: missionId, action:'reject', motifRejet }).then(() => {
                    handleCloseDialogRejet();
                    setMotifRejet('');
                }).catch(error => console.log(error));
            }
            if(missionIdProposition){
                await axiosPrivate.post('/mission/switchPropositionCommerciale',
                    { missionId: missionIdProposition, action:'reject', motifRejet }).then(() => {
                    handleCloseDialogRejet();
                    setMotifRejet('');
                }).catch(error => console.log(error));
            }
        } catch (error) {
            console.log(error);
        }
    };

    return(
        <Dialog
            open={openDialogRejet}
            onClose={handleCloseDialogRejet}
            fullScreen
            TransitionComponent={Transition}
            PaperProps={{
                style: {
                    background: '#FFFFFF',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseDialogRejet}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',alignItems:'center' ,minHeight:'900px',height:'100%', paddingBottom: '24px' }}>
                <div className='OrdreMissionFileFrame18'>
                    {/*<h5 className='OrdreMissionFileFrame19'>
                    Demande d&apos;interruption de idDoc
                    </h5>*/}
                    <div className='OrdreMissionFileFrame20'>
                        <div className='OrdreMissionFileFrame26'>
                            <div className='OrdreMissionFileFrame23'>
                                <p className='OrdreMissionFileFrame24'>{i18n.t('Motif de rejet')} </p>
                            </div>
                            <div className='OrdreMissionFileFrame27'>
                                <TextFieldComponent
                                    name="motifInterr"
                                    multiline
                                    minRows={4}
                                    value={motifRejet}
                                    onChange={(e) => setMotifRejet(e.target.value)}
                                    sx={{
                                        '& > :not(style)': {borderRadius: '8px'},
                                    }}
                                    style={{width:'100%'}}
                                    autoFocus={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='OrdreMissionFileFrame28'>
                        <Button
                            onClick={handleCloseDialogRejet}
                            variant="text"
                            style={{...buttonStyles(),...{width:device=='desktop'?'119px':'100%'}}}
                        >{i18n.t('Annuler')}</Button>

                        <Button
                            variant="contained"
                            style={{
                                ...buttonStyles(),...{background:'#EC5B56',color:'#FFFFFF',width:device=='desktop'?'119px':'100%'}
                            }}
                            onClick={()=>{rejeterDocument();}}
                        //</div>onClick={()=> switchPropositionCommerciale('reject')}
                        >{i18n.t('Envoyer')}</Button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default DialogRejet;
